import styled from 'styled-components';
import { GenerateQuantitiesButton } from './GenerateQuantitiesButton';
import { GenerateMenusSupplyOrdersButton } from './GenerateMenusSupplyOrdersButton';
import { UpdateMenusFromGsheetButton } from './UpdateMenuFromGsheet';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { Link } from 'react-router-dom';
import { formatDateAsAnniversary } from 'helpers/dateTimes';

export function HeaderButtons({ selectedDate }: { selectedDate: Date }) {
    return (
        <Filters>
            {/* <GenerateSiteMenusButton date={selectedDate} /> */}
            {/* <Link
                to={`/menu-quantities/${formatDateAsAnniversary({
                    dateTime: selectedDate,
                    useNewFormat: true,
                })}`}
            >
                <TotemPrimaryButton $minWidth="300px">Editer les quantités</TotemPrimaryButton>
            </Link> */}
            <GenerateQuantitiesButton date={selectedDate} />
            <Arrow>→</Arrow>
            <Link
                to={`/menu-product-arrangements/${formatDateAsAnniversary({
                    dateTime: selectedDate,
                    useNewFormat: true,
                })}`}
            >
                <TotemPrimaryButton>Menus par Gamme de produits</TotemPrimaryButton>
            </Link>
            <Arrow>→</Arrow>
            <UpdateMenusFromGsheetButton date={selectedDate} />
            <Arrow>→</Arrow>
            <GenerateMenusSupplyOrdersButton date={selectedDate} />
        </Filters>
    );
}

const Filters = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
`;

const Arrow = styled.span`
    font-size: 20px;
    color: ${({ theme }) => theme.textColor};
    display: flex;
    align-items: center;
    user-select: none;
`;
